import { IConfig } from "@server/server";
import { isTruthy } from "./strings";

export interface FeatureFlagWindow extends Window {
    featureFlags: any;
}

declare const window: FeatureFlagWindow;

export const processEnvFlags = () => {
    const flags = Object.keys(process.env).reduce((prev, curr) => {
        const obj: any = prev;
        if (/^FEATURE_FLAG/.test(curr)) {
            obj[curr] = process.env[curr];
        }
        return obj;
    }, {});

    return { ...flags };
};

const keysToUppercase = (obj: any) => {
    let key: any;
    let keys: string[] = Object.keys(obj);
    let n = keys.length;
    let newObj: any = {};
    while (n--) {
      key = keys[n];
      newObj[key.toUpperCase()] = obj[key];
    }
    return newObj;
};

export const isFeatureFlagActive = (flagName: string, href: string = null, config: IConfig = null) => {
    let searchStr = null;
    let featureFlags = {};
    if (typeof window !== "undefined") {
        searchStr = window.location.search;
        featureFlags = window.__MUSE__?.initialState?.config?.featureFlags || {};
    } else {
        searchStr = href?.split("?")[1] || "";
        featureFlags = config?.featureFlags || {};
    }
    const query = new URLSearchParams(searchStr);
    const params = Object.fromEntries(query);
    const normalizedParams = keysToUppercase(params);
    const normalizedFlag = flagName.toUpperCase();

    if (normalizedFlag in normalizedParams) {
        return isTruthy(normalizedParams[normalizedFlag]);
    }

    const normalizedServerFlags = keysToUppercase(featureFlags);
    if (normalizedFlag in normalizedServerFlags) {
        return isTruthy(normalizedServerFlags[normalizedFlag]);
    }
    return false;
};
